// 工事一覧画面
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useContext
} from 'react';
import './List.css';
import '../App.css';
import {
  useMediaQuery,
  FormControl,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Snackbar,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogActions,
  DialogTitle
} from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import {
  makeStyles,
  withStyles,
  createStyles,
  Theme
} from '@material-ui/core/styles';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import FooterComponent from '../components/FooterComponent';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useRecoilState } from 'recoil';
import {
  mainBlueColor,
  btnColor,
  isLoggedIn,
  userRole,
  constructData,
  employeeMasterData,
  userMenuId,
  userSiteManagePlanId,
  constructionExtInfoKey
} from '../GlobalState';
import {
  getConstructionList,
  deleteConstructionList,
  getExportConstructionItems,
  updateProgressStatus,
  updateEndDate
} from '../apicalls/construction';
import { getAllCustomerList } from '../apicalls/getCustomerDetails';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import LoadingComponent from '../components/LoadingComponent';
import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import 'date-fns';
import { Redirect, useHistory } from 'react-router-dom';
import { CSVLink } from 'react-csv';
import PaginationComponent from '../components/PaginationComponent';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import { parsePrice } from '../utils';
import { DatePickerInput } from '../components/atoms';
import { SITE_MANGE_PLAN_ACCESS_ALLOW } from '../const/Const';
import { ListButton } from '../components/parts/cloudStorage/style/style';
import { formatDatetime } from '../utils/common';
import { BasicSelect } from '../components/parts/input/BasicSelect';
import {
  TExtInfoData,
  TExtInfo,
  TAddInfoData,
  TColumn
} from '../types/ExtInfoBox';
import { TCheckListOption } from '../types/common';
import _ from 'lodash';
import { CustomTooltip } from '../components/tooltip/CustomTooltip';
import { tooltipContents } from '../components/tooltip/Const';
import { TParams } from '../types/ConstructionList';
import { useTheme } from '@material-ui/core/styles';
import { AuthInfoContext } from '../AuthContextProvider';
import { ROLE } from '../const/Const';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
  // "&:hover": {
  //   backgroundColor: "#a3a3a3"
  // },
  // '&$hover:hover': {
  //   // Set hover color
  //   backgroundColor: "#a3a3a3",
  // },
}))(TableRow);

interface State {
  arr: any;
}

interface CheckedState {
  check: any;
}

export const ConstructionList: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const history: any = useHistory();
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        height: 30,
        width: '100%'
      },
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      main: {
        minWidth: 700
      },
      table: {
        padding: 14,
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      // radio1: {
      //   color: 'red',
      //   '&$checked': {
      //     color: 'red',
      //   },
      // },
      radio1: {
        color: 'black',
        '&$checked': {
          color: '#758283'
        }
      },
      table1: {
        // padding: 8,
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 15
      }
    })
  );

  const matches2 = useMediaQuery('(min-width:900px)');
  const classes = useStyles();

  const [userPermission] = useRecoilState(userRole);
  const [userMenu] = useRecoilState(userMenuId);
  const [userSiteManagePlan, setUserSiteMangePlan] =
    useRecoilState<any>(userSiteManagePlanId);
  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => {
      setLoggedIn(newData);
    },
    [setLoggedIn]
  );

  const [checkBoxSelected, setCheckBoxSelected] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [constructionApiData, setConstructionApiData] =
    useRecoilState(constructData);
  const [constructionExtInfoRecoilState, setConstructionExtInfoRecoilState] =
    useRecoilState<TExtInfo | undefined>(constructionExtInfoKey);

  const changeConstructionApiData = useCallback(
    (newData: any) => setConstructionApiData(newData),
    [setConstructionApiData]
  );
  const [employeeMasterApiData, setEmployeeMasterApiData] =
    useRecoilState(employeeMasterData);
  const changeEmployeeMasterApiData = useCallback(
    (newData: any) => setEmployeeMasterApiData(newData),
    [setEmployeeMasterApiData]
  );
  const [apiData, setApiData] = useState<any>(
    constructionApiData !== null ? constructionApiData : []
  );
  const [loading, setLoading] = useState(
    constructionApiData !== null && constructionExtInfoRecoilState
      ? false
      : true
  );
  const [userData, setUserData] = useState<any>(
    employeeMasterApiData !== null ? employeeMasterApiData : []
  );

  const [progress_ids, setProgressIds] = useState<number[]>([]);
  // ログイン時の初期画面担当者選択を解除
  // const [assignedUser, setAssignedUser] = useState<any>(
  //   history.location.state ? history.location.state : 0 );
  const [assignedUser, setAssignedUser] = useState<any>(0);
  const [constructSub, setConstructSub] = useState('');
  const [constructionNumber, setConstructionNumber] = useState('');
  const [estimateNumber, setEstimateNumber] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [completionDateStart, setCompletionDateStart] = useState('');
  const [completionDateEnd, setCompletionDateEnd] = useState('');
  const [contractDateStart, setContractDateStart] = useState('');
  const [contractDateEnd, setContractDateEnd] = useState('');
  const [prefecture, setPrefecture] = useState('');
  const [address, setAddress] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(
    history.location.state?.currentPage || 1
  );
  const [displayLimit, setDisplayLimit] = useState<number>(10);

  const [openAlert, setOpenAlert] = useState(false);
  const [count, setCount] = useState<number>(0);
  const [selectedIds, setSelectedIds] = useState<State>({ arr: [] });
  const [checked, setChecked] = useState<CheckedState>({ check: [] });
  const [pressed, setPressed] = useState([]);
  const [isSelected, setSelection] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [selectedCompletionDateStart, setSelectedCompletionDateStart] =
    useState<Date | null>(null);
  const [selectedCompletionDateEnd, setSelectedCompletionDateEnd] =
    useState<Date | null>(null);
  const [selectedContractDateStart, setSelectedContractDateStart] =
    useState<Date | null>(null);
  const [selectedContractDateEnd, setSelectedContractDateEnd] =
    useState<Date | null>(null);
  const [myCheckExport, setMyCheckExport] = useState<string[]>([]);
  const [transactionData, setTransactionData] = useState<any>([]);
  const [openSelectModal, setopenSelectModal] = useState(false);
  const [customerId, setCustomerId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [contractEndDate, setContractEndDate] = useState<Date | null>(null);
  const [contractStartDate, setContractStartDate] = useState<Date | null>(null);
  const [customerdata, setCustomerdata] = useState<any>([]);
  const [extInfo, setExtInfo] = useState<TExtInfo>(
    constructionExtInfoRecoilState
      ? constructionExtInfoRecoilState
      : { columns: [], datas: [] }
  );
  const [addInfoData, setAddInfoData] = useState<TAddInfoData>();

  const [params, setParams] = useState<TParams>();
  const csvLink: any = useRef();
  const [transitionFlg, setTransitionFlg] = useState(
    history.location.state ? true : false
  );

  const [createModalSearchCustomerNames, setCreateModalSearchCustomerNames] =
    useState<string[]>([]);

  const checkListOptions: TCheckListOption[] = [
    { code: '工事番号' },
    { name: '工事件名' },
    { construct_type: '案件種別' },
    { renew_status: '新規・リピート' },
    { building_scale: '物件規模' },
    { site_prefecture: '現場住所/都道府県' },
    { site_address1: '現場住所/市区町村' },
    { site_address2: '現場住所/町名・番地' },
    { site_address3: '現場住所建物名/部屋番号など' },
    { contractor_name: '契約者名' },
    { contractor_prefecture: '契約者住所 都道府県' },
    { contractor_address1: '契約者住所 市区町村' },
    { contractor_address2: '契約者住所 町名・番地' },
    { contractor_address3: '契約者住所 建物名' },
    { contractor_tel: '契約者TEL' },
    { client_name: '顧客名' },
    { client_tel: '顧客TEL' },
    { client_prefecture: '顧客住所 都道府県' },
    { client_address1: '顧客住所 市区町村' },
    { client_address2: '顧客住所 町名・番地' },
    { client_address3: '顧客住所 建物名' },
    { assignee_names: '担当者情報' },
    { order_amount: '受注金額' },
    { expected_sales_amount: '売上見込' },
    { deposit_amount: '入金額' },
    { receivable_amount: '未収金額' },
    { planned_gross_profit: '計画粗利' },
    { execustion_gross_profit: '実行粗利' },
    { gross_profit_difference: '粗利予実差異' },
    { planned_cost: '計画原価（円)' },
    { execution_cost: '実行原価' },
    { cost_difference: '原価予実差異' },
    { small_expenses: '小口経費（円）（税別）' },
    { material_cost: '材料費（税別)' },
    { outsourcing_cost: '外注費（税別）' },
    { planned_gross_profit_rate: '計画粗利率' },
    { execustion_gross_profit_rate: '実行粗利率' },
    { gross_profit_rate_difference: '粗利率予実差異' },
    { planned_days: '予定工事日数' },
    { daily_gross_profit: '日割実行粗利' },
    { contract_date: '契約日' },
    { start_date: '着工日' },
    { end_date: '竣工日' },
    { billing_date: '請求日' },
    { payment_date: '完工入金日' },
    { failure_date: '不成立日' },
    { inspection_date: '点検日' },
    { expected_contract_date: '契約予定日' },
    { expected_start_date: '着工予定日' },
    { expected_end_date: '竣工予定日' },
    { expected_payment_date: '入金予定日' },
    { progress: '進行状況' },
    { contract_tax_rate: '契約書用税率（%)' },
    { company_name: '会社名' },
    { company_postal_code: '郵便番号' },
    { company_address: '所在地' },
    { company_phone_number: '電話番号' },
    { company_fax_number: 'Fax番号' }
  ];
  //{"renew_status":"新規・リピート"},{"building_scale":"物件規模"},{"site_prefecture":"現場住所/都道府県"} ,{"site_address1":"現場住所/市区町村"} ,{"site_address2":"現場住所/町名・番地"},{"site_address3":"現場住所建物名/部屋番号など"},{"contractor_name":"契約者名"},{"contractor_prefecture":"契約者住所 都道府県"} ,{"contractor_address1":"契約者住所 市区町村"} ,{"contractor_address2":"契約者住所 町名・番地"},{"contractor_address3":"契約者住所 建物名"},{"contractor_tel":"契約者TEL"} ,{"client_name":"顧客名"} ,{"client_tel":"顧客TEL"} ,{"client_prefecture":"顧客住所 都道府県"},{"client_address1":"顧客住所 市区町村"} ,{"client_address2":"顧客住所 町名・番地"} ,{"client_address3":"顧客住所 建物名"}
  //{"order_amount":"受注金額"},{"deposit_amount":"入金額"} ,{"receivable_amount":"未収金額"} ,{"planned_gross_profit_rate":"計画粗利"} ,{"execustion_gross_profit_rate":"実行粗利"} ,{"gross_profit_difference":"粗利予実差異"} ,{"":"計画原価（円）"} ,{"":"実行原価"},{"":"原価予実差異"} ,{"":"小口経費（円）（税別）"} ,{"":"材料費（税別）"} ,{"":"外注費（税別）"} ,{"":"計画粗利率"},{"":"実行粗利率"} ,{"":"粗利率予実差異"} ,{"":"予定工事日数"} ,{"":"日割実行粗利"}  {"contract_tax_rate":"契約書用税率（%）"},{"assignee_user":"担当者名"},{"customer_name":"顧客名"},{"code":"工事番号"},

  const PROGRESS_STATUS = [
    { id: 1, name: '未契約' },
    { id: 2, name: '営業中(Aランク)' },
    { id: 3, name: '営業中(Bランク)' },
    { id: 4, name: '営業中(Cランク)' },
    { id: 5, name: '契約' },
    { id: 6, name: '工事中' },
    { id: 7, name: '竣工' },
    { id: 8, name: '引渡' },
    { id: 9, name: '入金・完工' },
    { id: 10, name: '不成立' },
    { id: 11, name: '是正' }
  ];

  // 追加情報がある場合は、追加情報のキーとアイテムをcheckListOptionsに追加
  if (extInfo && extInfo.columns) {
    extInfo.columns.forEach(column => {
      let newOption: TCheckListOption = {};
      newOption[column.key] = column.item;
      checkListOptions.push(newOption);
    });
  }

  // 追加情報のチェックボックスを解除された場合は保存されたエクスポート項目から削除
  const setSelectedExportColumns = (
    columns: string[],
    extColumns?: TCheckListOption[]
  ) => {
    if (extColumns && extColumns.length > 0) {
      // extInfoのキーだけ取り出す
      const extInfoKeys = extColumns.map(column => column.key);
      columns = columns.filter(column => {
        // "data_" で始まる要素の場合、extInfoKeys に存在するかチェック
        if (column.startsWith('data_')) {
          return extInfoKeys.includes(column);
        }
        // "data_" で始まらない要素はそのまま保持
        return true;
      });
    }
    setMyCheckExport(columns);
  };

  /**
   * 竣工日検索:開始
   */
  const handleCompletionDateStartChange = (date: Date | null) => {
    setSelectedCompletionDateStart(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setCompletionDateStart(finaldate);
    setParams(prevParams => ({
      ...prevParams,
      selectedCompletionDateStart: date
    }));
    setParams(prevParams => ({
      ...prevParams,
      completionDateStart: finaldate
    }));
  };

  /**
   * 竣工日検索:終了
   */
  const handleCompletionDateEndChange = (date: Date | null) => {
    setSelectedCompletionDateEnd(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setCompletionDateEnd(finaldate);
    setParams(prevParams => ({
      ...prevParams,
      selectedCompletionDateEnd: date
    }));
    setParams(prevParams => ({ ...prevParams, completionDateEnd: finaldate }));
  };

  /**
   * 契約日検索:開始
   */
  const handleContractDateStartChange = (date: Date | null) => {
    setSelectedContractDateStart(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setContractDateStart(finaldate);
    setParams(prevParams => ({
      ...prevParams,
      selectedContractDateStart: date
    }));
    setParams(prevParams => ({ ...prevParams, contractDateStart: finaldate }));
  };

  /**
   * 契約日検索:終了
   */
  const handleContractDateEndChange = (date: Date | null) => {
    setSelectedContractDateEnd(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setContractDateEnd(finaldate);
    setParams(prevParams => ({ ...prevParams, selectedContractDateEnd: date }));
    setParams(prevParams => ({ ...prevParams, contractDateEnd: finaldate }));
  };

  /**
   * 契約日予定日検索:開始
   */
  const handleExpContractStartChange = (date: Date | null) => {
    setContractStartDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setStartDate(finaldate);
    setParams(prevParams => ({ ...prevParams, contractStartDate: date }));
    setParams(prevParams => ({ ...prevParams, startDate: finaldate }));
  };

  /**
   * 契約日予定日検索:終了
   */
  const handleExpContractEndChange = (date: Date | null) => {
    setContractEndDate(date);
    let finaldate: any = '';
    if (date) {
      finaldate = formatDatetime(date, 'YYYY-MM-DD');
    }
    setEndDate(finaldate);
    setParams(prevParams => ({ ...prevParams, contractEndDate: date }));
    setParams(prevParams => ({ ...prevParams, endDate: finaldate }));
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const getListOfUsers = useCallback(() => {
    getEmployeeMasterList('', 1).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setUserData(data.data);
            changeEmployeeMasterApiData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData, changeEmployeeMasterApiData]);

  const getListAllCustomerList = useCallback(() => {
    getAllCustomerList().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setCustomerdata(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData]);

  async function getConstructionListHavingParams(addInfoData?: TAddInfoData) {
    // 検索条件が保持されているとき、検索結果のリクエストを遅らせる

    let paramDatas = {
      progress_ids: progress_ids,
      assignedUser: assignedUser,
      constructSub: constructSub.trim(),
      customerName: customerName.trim(),
      completionDateStart:
        selectedCompletionDateStart !== null ? completionDateStart : '',
      completionDateEnd:
        selectedCompletionDateEnd !== null ? completionDateEnd : '',
      contractDateStart:
        selectedContractDateStart !== null ? contractDateStart : '',
      contractDateEnd: selectedContractDateEnd !== null ? contractDateEnd : '',
      startDate: contractStartDate !== null ? startDate : '',
      endDate: contractEndDate !== null ? endDate : '',
      constructionNumber: constructionNumber,
      estimateNumber: estimateNumber,
      prefecture: prefecture.trim(),
      address: address,
      currentPage: currentPage,
      displayLimit: displayLimit
    };

    // 画面遷移でstateを持っている状態の時はその値で検索処理を行う
    if (transitionFlg) {
      const params: TParams | undefined = history.location.state.params;
      if (params) {
        paramDatas = {
          progress_ids: params.progress_ids ? params.progress_ids : [],
          assignedUser: params.assignedUser ? params.assignedUser : 0,
          constructSub: params.constructSub ? params.constructSub.trim() : '',
          customerName: params.customerName ? params.customerName.trim() : '',
          completionDateStart: params.completionDateStart
            ? params.completionDateStart
            : '',
          completionDateEnd: params.completionDateEnd
            ? params.completionDateEnd
            : '',
          contractDateStart: params.contractDateStart
            ? params.contractDateStart
            : '',
          contractDateEnd: params.contractDateEnd ? params.contractDateEnd : '',
          startDate: params.startDate ? params.startDate : '',
          endDate: params.endDate ? params.endDate : '',
          constructionNumber: params.constructionNumber
            ? params.constructionNumber
            : '',
          estimateNumber: params.estimateNumber ? params.estimateNumber : '',
          prefecture: params.prefecture ? params.prefecture.trim() : '',
          address: params.address ? params.address : '',
          currentPage: 1,
          displayLimit: 10
        };
      }
    }

    let promise = new Promise((resolve, reject) => {
      setTimeout(() => resolve('done'), 100);
    });

    let result = await promise; // promiseが解決するまで(100ms)待つ

    getConstructionList(
      paramDatas.progress_ids,
      paramDatas.assignedUser,
      paramDatas.constructSub,
      paramDatas.customerName,
      paramDatas.completionDateStart,
      paramDatas.completionDateEnd,
      paramDatas.contractDateStart,
      paramDatas.contractDateEnd,
      paramDatas.startDate,
      paramDatas.endDate,
      paramDatas.constructionNumber,
      paramDatas.estimateNumber,
      paramDatas.prefecture,
      paramDatas.address,
      paramDatas.currentPage,
      paramDatas.displayLimit,
      addInfoData
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            changeConstructionApiData(data.data);
            setApiData(data.data);
            setCount(data.data.length);
            setLoading(false);
            setSelectedIds({ arr: [] });
            setChecked({ check: [] });
            setSelection(false);
            setPageCount(data.page_count);
            setSelectedExportColumns(
              data.selected_columns,
              data.extInfo?.columns
            );
          }
        }
      }
    });
  }

  const getListOfConstructions = useCallback(
    (addInfoData?: TAddInfoData) => {
      let paramDatas = {
        progress_ids: progress_ids,
        assignedUser: assignedUser,
        constructSub: constructSub.trim(),
        customerName: customerName.trim(),
        completionDateStart:
          selectedCompletionDateStart !== null ? completionDateStart : '',
        completionDateEnd:
          selectedCompletionDateEnd !== null ? completionDateEnd : '',
        contractDateStart:
          selectedContractDateStart !== null ? contractDateStart : '',
        contractDateEnd:
          selectedContractDateEnd !== null ? contractDateEnd : '',
        startDate: contractStartDate !== null ? startDate : '',
        endDate: contractEndDate !== null ? endDate : '',
        constructionNumber: constructionNumber,
        estimateNumber: estimateNumber,
        prefecture: prefecture.trim(),
        address: address,
        currentPage: currentPage,
        displayLimit: displayLimit
      };

      // 画面遷移でstateを持っている状態の時はその値で検索処理を行う
      if (transitionFlg) {
        const params: TParams | undefined = history.location.state.params;
        if (params) {
          paramDatas = {
            progress_ids: params.progress_ids ? params.progress_ids : [],
            assignedUser: params.assignedUser ? params.assignedUser : 0,
            constructSub: params.constructSub ? params.constructSub.trim() : '',
            customerName: params.customerName ? params.customerName.trim() : '',
            completionDateStart: params.completionDateStart
              ? params.completionDateStart
              : '',
            completionDateEnd: params.completionDateEnd
              ? params.completionDateEnd
              : '',
            contractDateStart: params.contractDateStart
              ? params.contractDateStart
              : '',
            contractDateEnd: params.contractDateEnd
              ? params.contractDateEnd
              : '',
            startDate: params.startDate ? params.startDate : '',
            endDate: params.endDate ? params.endDate : '',
            constructionNumber: params.constructionNumber
              ? params.constructionNumber
              : '',
            estimateNumber: params.estimateNumber ? params.estimateNumber : '',
            prefecture: params.prefecture ? params.prefecture.trim() : '',
            address: params.address ? params.address : '',
            currentPage: 1,
            displayLimit: 10
          };
        }
      }

      if (
        paramDatas.progress_ids.length != 0 ||
        paramDatas.assignedUser != 0 ||
        paramDatas.constructSub != '' ||
        paramDatas.customerName != '' ||
        paramDatas.completionDateStart != '' ||
        paramDatas.completionDateEnd != '' ||
        paramDatas.contractDateStart != '' ||
        paramDatas.contractDateEnd != '' ||
        paramDatas.startDate != '' ||
        paramDatas.endDate != '' ||
        paramDatas.constructionNumber != '' ||
        paramDatas.estimateNumber != '' ||
        paramDatas.prefecture != ''
      ) {
        getConstructionListHavingParams(addInfoData);
      } else {
        getConstructionList(
          paramDatas.progress_ids,
          paramDatas.assignedUser,
          paramDatas.constructSub,
          paramDatas.customerName,
          paramDatas.completionDateStart,
          paramDatas.completionDateEnd,
          paramDatas.contractDateStart,
          paramDatas.contractDateEnd,
          paramDatas.startDate,
          paramDatas.endDate,
          paramDatas.constructionNumber,
          paramDatas.estimateNumber,
          paramDatas.prefecture,
          paramDatas.address,
          paramDatas.currentPage,
          paramDatas.displayLimit,
          addInfoData
        ).then((data: any) => {
          if (data === 'Not logged in!') {
            changeLoggedInData('Not logged in!');
          } else {
            if (typeof data === 'string') {
              setErrorMessage(data);
              setOpen(true);
            } else {
              if (data.error) {
                setErrorMessage(data.error);
                setOpen(true);
              } else {
                changeConstructionApiData(data.data);
                setApiData(data.data);
                setCount(data.data.length);
                setLoading(false);
                setSelectedIds({ arr: [] });
                setChecked({ check: [] });
                setSelection(false);
                setPageCount(data.page_count);
                setSelectedExportColumns(
                  data.selected_columns,
                  data.ext_info?.columns
                );
                setExtInfo(data.ext_info);
                setConstructionExtInfoRecoilState(data.ext_info);
              }
            }
          }
        });
      }
    },
    [
      assignedUser,
      changeConstructionApiData,
      changeLoggedInData,
      constructSub,
      constructionNumber,
      estimateNumber,
      contractDateEnd,
      currentPage,
      customerName,
      displayLimit,
      contractDateStart,
      progress_ids,
      selectedCompletionDateStart,
      selectedCompletionDateEnd,
      selectedContractDateEnd,
      selectedContractDateStart,
      contractEndDate,
      contractStartDate,
      endDate,
      startDate,
      prefecture,
      address
    ]
  );

  useEffect(() => {
    // 画面遷移の際のステートがなければ処理しない
    if (!history.location.state) {
      return;
    }

    // パラメーター取得
    const params: TParams | undefined = history.location.state.params;
    setParams(params);

    if (params) {
      setProgressIds(params.progress_ids ? params.progress_ids : []); // 進行状況設定
      setAssignedUser(params.assignedUser ? params.assignedUser : 0); // 担当者設定
      setConstructSub(params.constructSub ? params.constructSub : ''); // 工事件名設定
      setConstructionNumber(
        params.constructionNumber ? params.constructionNumber : ''
      ); // 工事番号設定
      setEstimateNumber(params.estimateNumber ? params.estimateNumber : ''); // 見積書番号設定
      setCustomerName(params.customerName ? params.customerName : ''); // 顧客名設定
      setSelectedCompletionDateStart(
        params.selectedCompletionDateStart
          ? params.selectedCompletionDateStart
          : null
      ); // 竣工開始日(検索窓への入力)設定
      setCompletionDateStart(
        params.completionDateStart ? params.completionDateStart : ''
      ); // 竣工開始日設定
      setSelectedCompletionDateEnd(
        params.selectedCompletionDateEnd
          ? params.selectedCompletionDateEnd
          : null
      ); // 竣工終了日(検索窓への入力)設定
      setCompletionDateEnd(
        params.completionDateEnd ? params.completionDateEnd : ''
      ); // 竣工終了日設定
      setSelectedContractDateStart(
        params.selectedContractDateStart
          ? params.selectedContractDateStart
          : null
      ); // 契約開始日(検索窓への入力)設定
      setContractDateStart(
        params.contractDateStart ? params.contractDateStart : ''
      ); // 契約開始日設定
      setSelectedContractDateEnd(
        params.selectedContractDateEnd ? params.selectedContractDateEnd : null
      ); // 契約終了日(検索窓への入力)設定
      setContractDateEnd(params.contractDateEnd ? params.contractDateEnd : ''); // 契約終了日設定
      setContractStartDate(
        params.contractStartDate ? params.contractStartDate : null
      ); // 契約開始予定日(検索窓への入力)設定
      setStartDate(params.startDate ? params.startDate : ''); // 契約開始予定日設定
      setContractEndDate(
        params.contractEndDate ? params.contractEndDate : null
      ); // 契約終了予定日(検索窓への入力)設定
      setEndDate(params.endDate ? params.endDate : ''); // 契約終了予定日設定
      setPrefecture(params.prefecture ? params.prefecture : ''); // 都道府県設定
      setTransitionFlg(false); // 画面遷移フラグ
    }
  }, []);

  useEffect(() => {
    getListOfUsers();
    getListAllCustomerList();
  }, [getListOfUsers, getListAllCustomerList]);

  useEffect(() => {
    // 工事検索のとき値が変更されてから500ミリ秒後のクエリのみ実行する
    const timeoutId = setTimeout(() => {
      getListOfConstructions(addInfoData);
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [currentPage, displayLimit, getListOfConstructions]);

  const handleOpenSelectModal = () => {
    setopenSelectModal(true);
  };
  const handleCloseSelectModal = () => {
    setopenSelectModal(false);
  };
  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleClickOpenAlert = () => {
    if (userPermission !== 1) {
      setErrorMessage('削除の権限がありません。');
      setOpen(true);
    } else {
      setOpenAlert(true);
    }
  };

  function handleChange(index: number) {
    for (let i = 0; i < count; i++) {
      if (checked.check[i] === false) {
        setSelection(false);
      }
    }

    let checkedBox: any = [...checked.check];
    checkedBox[index] = !checked.check[index];
    setChecked({ check: checkedBox });
  }

  const selectAllCheckBoxPressed = () => {
    let a = [];
    if (isSelected === false) {
      let subjectArray: any = [];
      setSelectedIds({ arr: [] });

      setChecked({ check: [] });
      setPressed([]);
      for (let i = 1; i <= count; i++) {
        a.push(true);
        setChecked({ check: a });
      }

      apiData.map((item: any, k: number) => subjectArray.push(item.id));
      setSelectedIds({ arr: subjectArray });
    } else {
      setSelectedIds({ arr: [] });
      for (let i = 1; i <= count; i++) {
        a.push(false);
        setChecked({ check: a });
      }
    }
  };

  const deleteSelectedConstructions = () => {
    setOpenAlert(false);
    deleteConstructionList(selectedIds.arr).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setOpenAlert(false);
            getListOfConstructions(addInfoData);
          }
        }
      }
    });
  };
  const updateStatus = (id: number, status: number) => {
    updateProgressStatus(id, status)
      .then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else if (data.error) {
          setErrorMessage(data.error);
          setOpen(true);
        } else {
          setErrorMessage(data.message);
          setOpenSuccess(true);
          getListOfConstructions();
        }
      })
      .catch(err => {
        setErrorMessage('予期しないエラーが発生しました');
        setOpen(true);
      });
  };
  /**
   * 竣工日更新
   */
  const handleEndDate = (id: number, endDate: Date | null) => {
    let finaldate: any = '';
    if (endDate) {
      finaldate = formatDatetime(endDate, 'YYYY-MM-DD');
    }
    updateEndDate(id, finaldate).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            getListOfConstructions();
          }
        }
      }
    });
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleExport = () => {
    getExportConstructionItems(
      myCheckExport,
      progress_ids,
      assignedUser,
      constructSub.trim(),
      customerName.trim(),
      selectedCompletionDateStart !== null ? completionDateStart : '',
      selectedCompletionDateEnd !== null ? completionDateEnd : '',
      selectedContractDateStart !== null ? contractDateStart : '',
      selectedContractDateEnd !== null ? contractDateEnd : '',
      contractStartDate !== null ? startDate : '',
      contractEndDate !== null ? endDate : '',
      constructionNumber,
      prefecture.trim(),
      address,
      addInfoData
    ).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setTransactionData(data.rows_list);
            csvLink.current.link.click();
            handleCloseModal();
          }
        }
      }
    });
  };

  /**
   * 追加情報の行を追加
   * @param row
   * @returns
   */
  const addRow = (row: any) => {
    const extInfoData: TExtInfoData | undefined = extInfo?.datas.find(
      item => item.construct_id == row.id
    );
    return (
      <>
        {extInfo?.columns &&
          extInfo?.columns.length > 0 &&
          extInfo?.columns.map(column => {
            return (
              <StyledTableCell
                className={classes.table1}
                style={{ minWidth: 100 }}
                align='right'
                onClick={() => {
                  history.push(`/constructions/${row.id}/edit`, {
                    state: row.id,
                    currentPage: currentPage
                  });
                }}
              >
                {extInfoData ? extInfoData[column.key] : ''}
              </StyledTableCell>
            );
          })}
      </>
    );
  };

  const addFildOnChange = (value: any, column: TColumn) => {
    let copyAddInfoData = _.cloneDeep(addInfoData);
    if (!copyAddInfoData) {
      copyAddInfoData = {};
    }

    if (value) {
      copyAddInfoData[column.key] = value;
    } else {
      if (copyAddInfoData[column.key]) {
        if (Object.keys(copyAddInfoData).length > 1) {
          delete copyAddInfoData[column.key];
        } else {
          copyAddInfoData = undefined;
        }
      }
    }
    setAddInfoData(copyAddInfoData);
  };

  const [fullWidth] = useState(true);
  const [maxWidth] = useState<DialogProps['maxWidth']>('sm');

  // サイズ調整
  const theme = useTheme();
  const isSmDownScreen = useMediaQuery(theme.breakpoints.up('sm'));
  const isMdDownScreen = useMediaQuery(theme.breakpoints.up('md'));

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent patternName='constructions' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            overflow: 'hidden',
            backgroundColor: '#F5F5F5',
            padding: 15,
            minHeight: window.innerHeight - 150
          }}
        >
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSuccess}
            autoHideDuration={4000}
            onClose={handleCloseSuccess}
          >
            <Alert onClose={handleCloseSuccess} severity='success'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <Dialog
            open={openAlert}
            onClose={handleCloseAlert}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {
                '工事に紐づくデータも一緒に削除されます。本当に削除してよろしいですか。'
              }
            </DialogTitle>
            <DialogActions>
              <Button onClick={handleCloseAlert} color='primary'>
                キャンセル
              </Button>
              <Button
                onClick={() => {
                  deleteSelectedConstructions();
                }}
                color='primary'
                autoFocus
              >
                削除
              </Button>
            </DialogActions>
          </Dialog>

          <div>
            {/* 進行状況 */}
            {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
              <div style={{ maxWidth: 1440 }}>
                <div style={{ marginBottom: 5 }}>
                  <span>進行状況:</span>
                </div>
                <FormGroup
                  row
                  style={{
                    backgroundColor: '#FFFFFF',
                    padding: '5px 20px',
                    border: '1px solid',
                    borderRadius: 5,
                    marginBottom: 20
                  }}
                >
                  {PROGRESS_STATUS.map(status => (
                    <FormControlLabel
                      key={status.id}
                      label={status.name}
                      style={{ marginRight: 30 }}
                      control={
                        <Checkbox
                          checked={progress_ids.includes(status.id)}
                          onChange={e => {
                            if (e.target.checked) {
                              setProgressIds([...progress_ids, status.id]);
                            } else {
                              setProgressIds(
                                progress_ids.filter(id => id !== status.id)
                              );
                            }
                          }}
                          style={{
                            width: 30,
                            height: 30,
                            color: checked ? buttonColor : '#758283'
                          }}
                        />
                      }
                    />
                  ))}
                </FormGroup>
              </div>
            )}

            <div
              style={{
                overflow: 'hidden',
                display: 'flex',
                flexWrap: 'wrap'
              }}
            >
              {/* 担当者 */}
              {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                <div
                  style={{ marginRight: 20, marginBottom: 10 }}
                  className='select-div'
                >
                  <div style={{ paddingLeft: 5 }}>
                    <FormControl className={classes.formControl}>
                      <BasicSelect
                        value={assignedUser}
                        onChange={e => {
                          setAssignedUser(parseInt(e.target.value));
                          setParams(prevParams => ({
                            ...prevParams,
                            assignedUser: e.target.value
                          }));
                        }}
                        inputProps={{ 'aria-label': 'age' }}
                        disableUnderline
                      >
                        <option value={0}>担当者</option>
                        {getUserSelectOptions(userData)}
                      </BasicSelect>
                    </FormControl>
                  </div>
                </div>
              )}

              {/* 工事件名 */}
              <div>
                <input
                  value={constructSub}
                  onChange={e => {
                    setConstructSub(e.target.value);
                    setParams(prevParams => ({
                      ...prevParams,
                      constructSub: e.target.value
                    }));
                  }}
                  style={{
                    marginBottom: 10,
                    marginRight: 20,
                    backgroundColor: '#FFFFFF'
                  }}
                  className={classes.formControl1}
                  placeholder='工事件名'
                />
              </div>

              {/* 顧客名 */}
              <div>
                <input
                  value={customerName}
                  onChange={e => {
                    setCustomerName(e.target.value);
                    setParams(prevParams => ({
                      ...prevParams,
                      customerName: e.target.value
                    }));
                  }}
                  style={{
                    marginBottom: 10,
                    marginRight: 20,
                    backgroundColor: '#FFFFFF'
                  }}
                  className={classes.formControl1}
                  placeholder='顧客名'
                />
              </div>
              {/* 工事番号 */}
              {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                <div>
                  <input
                    value={constructionNumber}
                    onChange={e => {
                      setConstructionNumber(e.target.value);
                      setParams(prevParams => ({
                        ...prevParams,
                        constructionNumber: e.target.value
                      }));
                    }}
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='工事番号'
                  />
                </div>
              )}
              {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                <div>
                  <input
                    value={estimateNumber}
                    onChange={e => {
                      setEstimateNumber(e.target.value);
                      setParams(prevParams => ({
                        ...prevParams,
                        estimateNumber: e.target.value
                      }));
                    }}
                    style={{
                      marginBottom: 10,
                      marginRight: 20,
                      backgroundColor: '#FFFFFF'
                    }}
                    className={classes.formControl1}
                    placeholder='見積書番号'
                  />
                </div>
              )}
            </div>

            <div
              style={{
                overflow: 'hidden',
                display: 'flex',
                flexWrap: 'wrap'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  marginRight: '5px'
                }}
              >
                {userMenu !== 'Storage' && (
                  <>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span>竣工日:</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div
                        style={{
                          marginBottom: 10,
                          marginTop: 10,
                          backgroundColor: '#FFFFFF',
                          height: 27,
                          paddingBottom: 5,
                          paddingLeft: 5,
                          maxWidth: 200
                        }}
                        className='select-div'
                      >
                        <DatePickerInput
                          id='date-picker-inline'
                          date={selectedCompletionDateStart}
                          emptyLabel='開始日'
                          onChange={handleCompletionDateStartChange}
                          maxDate={
                            selectedCompletionDateEnd
                              ? selectedCompletionDateEnd
                              : undefined
                          }
                        />
                      </div>
                      <span style={{ fontSize: '20px' }}>~</span>
                      <div
                        style={{
                          marginBottom: 10,
                          marginTop: 10,
                          backgroundColor: '#FFFFFF',
                          height: 27,
                          paddingBottom: 5,
                          paddingLeft: 5,
                          maxWidth: 200
                        }}
                        className='select-div'
                      >
                        <DatePickerInput
                          id='date-picker-inline'
                          date={selectedCompletionDateEnd}
                          emptyLabel='終了日'
                          onChange={handleCompletionDateEndChange}
                          minDate={
                            selectedCompletionDateStart
                              ? selectedCompletionDateStart
                              : undefined
                          }
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  marginRight: '5px'
                }}
              >
                {userMenu != 'Storage' &&
                  authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span> 契約日:</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                          style={{
                            marginBottom: 10,
                            marginTop: 10,
                            backgroundColor: '#FFFFFF',
                            height: 27,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            maxWidth: 200
                          }}
                          className={'select-div'}
                        >
                          <DatePickerInput
                            id='date-picker-inline'
                            date={selectedContractDateStart}
                            emptyLabel='開始日'
                            onChange={handleContractDateStartChange}
                            maxDate={
                              selectedContractDateEnd
                                ? selectedContractDateEnd
                                : undefined
                            }
                          />
                        </div>
                        <span style={{ fontSize: '20px' }}>~</span>
                        <div
                          style={{
                            marginBottom: 10,
                            marginTop: 10,
                            backgroundColor: '#FFFFFF',
                            height: 27,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            maxWidth: 200
                          }}
                          className={'select-div'}
                        >
                          <DatePickerInput
                            id='date-picker-inline'
                            date={selectedContractDateEnd}
                            emptyLabel='終了日'
                            onChange={handleContractDateEndChange}
                            minDate={
                              selectedContractDateStart
                                ? selectedContractDateStart
                                : undefined
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
              </div>

              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  marginRight: '5px'
                }}
              >
                {userMenu != 'Storage' &&
                  authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                    <>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span>契約予定日:</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                          style={{
                            marginBottom: 10,
                            marginTop: 10,
                            backgroundColor: '#FFFFFF',
                            height: 27,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            maxWidth: 200
                          }}
                          className={'select-div'}
                        >
                          <DatePickerInput
                            id='date-picker-inline'
                            date={contractStartDate}
                            emptyLabel='開始日'
                            onChange={handleExpContractStartChange}
                            maxDate={
                              contractEndDate ? contractEndDate : undefined
                            }
                          />
                        </div>
                        <span style={{ fontSize: '20px' }}>~</span>
                        <div
                          style={{
                            marginBottom: 10,
                            marginTop: 10,
                            backgroundColor: '#FFFFFF',
                            height: 27,
                            paddingBottom: 5,
                            paddingLeft: 5,
                            maxWidth: 200
                          }}
                          className={'select-div'}
                        >
                          <DatePickerInput
                            id='date-picker-inline'
                            date={contractEndDate}
                            emptyLabel='終了日'
                            onChange={handleExpContractEndChange}
                            minDate={
                              contractStartDate ? contractStartDate : undefined
                            }
                          />
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>

            <div
              style={{
                overflow: 'hidden',
                display: 'flex',
                flexWrap: 'wrap'
              }}
            >
              <div>
                <input
                  value={prefecture}
                  onChange={e => {
                    setPrefecture(e.target.value);
                    setParams(prevParams => ({
                      ...prevParams,
                      prefecture: e.target.value
                    }));
                  }}
                  style={{
                    marginBottom: 10,
                    marginRight: 20,
                    backgroundColor: '#FFFFFF'
                  }}
                  className={classes.formControl1}
                  placeholder='都道府県'
                />
              </div>
              <div>
                <input
                  value={address}
                  onChange={e => {
                    setAddress(e.target.value);
                    setParams(prevParams => ({
                      ...prevParams,
                      address: e.target.value
                    }));
                  }}
                  style={{
                    marginBottom: 10,
                    marginRight: 20,
                    backgroundColor: '#FFFFFF'
                  }}
                  className={classes.formControl1}
                  placeholder='市区町村・番地など'
                />
              </div>

              {authInfo?.role != ROLE['OUTSIDE_PARTNER'] &&
                extInfo?.columns &&
                extInfo?.columns.length > 0 &&
                extInfo?.columns.map((column, index) => {
                  return (
                    <div key={index}>
                      <input
                        onChange={e => {
                          addFildOnChange(e.target.value, column);
                        }}
                        style={{
                          marginBottom: 10,
                          marginRight: 20,
                          backgroundColor: '#FFFFFF'
                        }}
                        className={classes.formControl1}
                        placeholder={column.item}
                      />
                    </div>
                  );
                })}

              <div>
                <Button
                  style={{
                    marginBottom: 10,
                    marginRight: 20,
                    backgroundColor: buttonColor
                  }}
                  variant='contained'
                  color='primary'
                  onClick={() => {
                    getListOfConstructions(addInfoData);
                    setCurrentPage(1);
                  }}
                >
                  検索
                </Button>
              </div>
            </div>
          </div>

          <div
            style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}
          >
            <div
              className='table-top-container-customer'
              style={{
                display: 'flex',
                flexDirection: isSmDownScreen ? 'row' : 'column'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  width: isSmDownScreen ? '20%' : '100%'
                }}
              >
                <div style={{ fontWeight: 'bold' }}>工事一覧</div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: isMdDownScreen ? 'row' : 'column'
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: isMdDownScreen ? 'center' : 'end'
                  }}
                >
                  <div
                    style={{ marginRight: 10, marginBottom: 5 }}
                    className='select-div'
                  >
                    <div style={{ paddingLeft: 5 }}>
                      <FormControl className={classes.formControl}>
                        <BasicSelect
                          value={displayLimit}
                          onChange={e => {
                            setCurrentPage(1);
                            setDisplayLimit(parseInt(e.target.value));
                          }}
                          inputProps={{ 'aria-label': 'age' }}
                          disableUnderline
                        >
                          {/* <option value={0}>結果の制限</option> */}
                          <option value={10}>10件</option>
                          <option value={30}>30件</option>
                          <option value={50}>50件</option>
                          <option value={100}>100件</option>
                          <option value={150}>150件</option>
                          <option value={200}>200件</option>
                        </BasicSelect>
                      </FormControl>
                    </div>
                  </div>
                </div>

                {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                  <div>
                    {/* 画面の幅でアイコン付きボタンとアイコンなしボタンを使い分ける */}
                    {isSmDownScreen ? (
                      <div>
                        <CustomTooltip
                          title={tooltipContents.constructionsCreateNew}
                          placement='top'
                        >
                          <Button
                            style={{
                              backgroundColor: buttonColor,
                              marginRight: 10,
                              marginBottom: !matches2 ? 10 : 0
                            }}
                            variant='contained'
                            color='secondary'
                            startIcon={<NoteAddIcon />}
                            onClick={handleOpenSelectModal}
                          >
                            新規作成
                          </Button>
                        </CustomTooltip>
                        <CustomTooltip
                          title={tooltipContents.constructionsSelectDelete}
                          placement='top'
                        >
                          <Button
                            style={{
                              backgroundColor: buttonColor,
                              marginRight: 10,
                              marginBottom: !matches2 ? 10 : 0
                            }}
                            variant='contained'
                            color='secondary'
                            startIcon={<DeleteIcon />}
                            onClick={() => {
                              if (selectedIds.arr.length <= 0) {
                                alert('対象を選択してください。');
                              } else {
                                handleClickOpenAlert();
                              }
                            }}
                          >
                            選択削除
                          </Button>
                        </CustomTooltip>
                        <CustomTooltip
                          title={tooltipContents.constructionsExport}
                          placement='top'
                        >
                          <Button
                            style={{
                              backgroundColor: buttonColor,
                              marginBottom: !matches2 ? 10 : 0
                            }}
                            onClick={handleOpenModal}
                            variant='contained'
                            color='secondary'
                            startIcon={<GetAppIcon />}
                          >
                            エクスポート
                          </Button>
                        </CustomTooltip>
                      </div>
                    ) : (
                      <div>
                        <CustomTooltip
                          title={tooltipContents.constructionsCreateNew}
                          placement='top'
                        >
                          <Button
                            style={{
                              backgroundColor: buttonColor,
                              marginRight: 8,
                              marginBottom: !matches2 ? 10 : 0
                            }}
                            variant='contained'
                            color='secondary'
                            onClick={handleOpenSelectModal}
                          >
                            新規作成
                          </Button>
                        </CustomTooltip>
                        <CustomTooltip
                          title={tooltipContents.constructionsSelectDelete}
                          placement='top'
                        >
                          <Button
                            style={{
                              backgroundColor: buttonColor,
                              marginRight: 8,
                              marginBottom: !matches2 ? 10 : 0
                            }}
                            variant='contained'
                            color='secondary'
                            onClick={() => {
                              if (selectedIds.arr.length <= 0) {
                                alert('対象を選択してください。');
                              } else {
                                handleClickOpenAlert();
                              }
                            }}
                          >
                            選択削除
                          </Button>
                        </CustomTooltip>
                        {userMenu != 'Storage' && (
                          <CustomTooltip
                            title={tooltipContents.constructionsExport}
                            placement='top'
                          >
                            <Button
                              style={{
                                backgroundColor: buttonColor,
                                marginBottom: !matches2 ? 10 : 0
                              }}
                              onClick={handleOpenModal}
                              variant='contained'
                              color='secondary'
                            >
                              エクスポート
                            </Button>
                          </CustomTooltip>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
              {/* 右おわり */}

              <Dialog
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                open={openSelectModal}
                onClose={handleCloseSelectModal}
                scroll='paper'
                aria-labelledby='set_construct_title'
                aria-describedby='constructs'
              >
                <DialogTitle id='set_construct_title'>
                  新規作成する工事の顧客を選択してください
                </DialogTitle>
                <DialogContent>
                  <div>
                    <input
                      maxLength={30}
                      onChange={e => {
                        setCreateModalSearchCustomerNames(
                          String(e.target.value).split(' ')
                        );
                      }}
                      style={{
                        marginBottom: 10,
                        marginRight: 20,
                        backgroundColor: '#FFFFFF',
                        width: '100%'
                      }}
                      className={classes.formControl1}
                      placeholder='顧客名'
                    />
                  </div>
                  <RadioGroup
                    aria-label='Select Customer Name'
                    name='Select Customer Name'
                    value={customerId}
                    onChange={e => setCustomerId(e.target.value)}
                  >
                    {customerdata.length > 0 &&
                      customerdata
                        .filter(
                          (customer: any) =>
                            createModalSearchCustomerNames.length === 0 ||
                            createModalSearchCustomerNames.some(customerName =>
                              customer.name.includes(customerName)
                            )
                        )
                        .map((filtered_customer: any) => (
                          <FormControlLabel
                            value={filtered_customer.id}
                            checked={
                              Number(customerId) ===
                              Number(filtered_customer.id)
                            }
                            key={filtered_customer.id}
                            control={<Radio style={{ color: '#758283' }} />}
                            label={filtered_customer.name}
                          />
                        ))}
                  </RadioGroup>
                </DialogContent>
                <DialogActions>
                  <Button
                    autoFocus
                    onClick={() => {
                      handleCloseSelectModal();
                      setCreateModalSearchCustomerNames([]);
                    }}
                    style={{ color: 'black' }}
                  >
                    キャンセル
                  </Button>
                  <Button
                    disabled={customerId === ''}
                    onClick={() => {
                      history.push(`/constructions/create`, {
                        state: customerId,
                        params: params
                      });
                    }}
                    style={{ color: 'black' }}
                  >
                    新規作成
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
            <Dialog
              fullWidth={fullWidth}
              maxWidth={maxWidth}
              open={openModal}
              onClose={handleCloseModal}
              aria-labelledby='max-width-dialog-title'
            >
              <DialogContent>
                <DialogContentText id='alert-dialog-description'>
                  <div>
                    <div
                      className='border1'
                      style={{ display: 'flex', flexDirection: 'row' }}
                    >
                      <div style={{ flex: 3 }}>
                        <div
                          style={{ padding: 10, backgroundColor: mainColor }}
                        >
                          <div style={{ color: '#FFFFFF' }}>エクスポート</div>
                        </div>
                      </div>
                    </div>

                    {checkListOptions.map((i: any, index) => (
                      <div
                        className='border1'
                        style={{ display: 'flex', flexDirection: 'row' }}
                      >
                        <div
                          style={{
                            flex: 3,
                            backgroundColor:
                              index % 2 === 0 ? '#F5F5F5' : '#FFFFFF'
                          }}
                        >
                          <div style={{ padding: 3 }}>
                            <Checkbox
                              name='expertCheckbox'
                              checked={
                                myCheckExport.includes(
                                  Object.keys(i).toString()
                                )
                                  ? true
                                  : false
                              }
                              onClick={e => {
                                var ind = myCheckExport.indexOf(
                                  Object.keys(i).toString()
                                );
                                if (ind === -1) {
                                  setMyCheckExport([
                                    ...myCheckExport,
                                    Object.keys(i).toString()
                                  ]);
                                } else {
                                  setMyCheckExport(
                                    myCheckExport.filter(
                                      (char: any, aa: any) => aa !== ind
                                    )
                                  );
                                }
                              }}
                              style={{
                                color: myCheckExport.includes(
                                  Object.keys(i).toString()
                                )
                                  ? buttonColor
                                  : '#758283'
                              }}
                            />
                            {Object.values(i)}
                          </div>
                        </div>
                      </div>
                    ))}
                    <div></div>
                  </div>
                </DialogContentText>
              </DialogContent>
              <div
                style={{
                  marginBottom: 20,
                  marginTop: 10,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <Button
                  style={{ backgroundColor: buttonColor }}
                  variant='contained'
                  color='primary'
                  onClick={handleExport}
                  startIcon={<GetAppIcon />}
                >
                  保存
                </Button>
                <CSVLink
                  data={transactionData}
                  filename='工事一覧.csv'
                  className='hidden'
                  ref={csvLink}
                  target='_blank'
                />
              </div>
            </Dialog>

            {/* <CSVLink
                  data={exportData}
                  filename={"工事一覧.csv"}
                  target="_blank"
                  style={{ textDecorationLine: "none" }}
                >
                  <Button
                    style={{
                      backgroundColor: buttonColor,
                      marginBottom: !matches2 ? 10 : 0,
                    }}
                    variant="contained"
                    color="secondary"
                    startIcon={<GetAppIcon />}
                  >
                    エクスポート
                  </Button>
                </CSVLink>
              </div>
            </div> */}

            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                      <>
                        <StyledTableCell
                          className={classes.table}
                          align='center'
                        >
                          <CustomTooltip
                            title={tooltipContents.selectDelete}
                            placement='top'
                          >
                            <Checkbox
                              checked={isSelected}
                              onClick={() => {
                                setSelection(!isSelected);
                                selectAllCheckBoxPressed();
                              }}
                              style={{
                                color: isSelected ? buttonColor : '#FFFFFF'
                              }}
                            />
                          </CustomTooltip>
                        </StyledTableCell>
                        {userMenu != 'Storage' && (
                          <StyledTableCell
                            style={{ minWidth: 100 }}
                            className={classes.table}
                            align='center'
                          >
                            進行状況
                          </StyledTableCell>
                        )}
                        <StyledTableCell
                          style={{ minWidth: 100 }}
                          className={classes.table}
                          align='center'
                        >
                          担当者名
                        </StyledTableCell>
                      </>
                    )}
                    <StyledTableCell
                      style={{ minWidth: 100 }}
                      className={classes.table}
                      align='center'
                    >
                      工事件名
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 100 }}
                      className={classes.table}
                      align='center'
                    >
                      案件種別
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 80 }}
                      className={classes.table}
                      align='center'
                    >
                      顧客名
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ minWidth: 100 }}
                      className={classes.table}
                      align='center'
                    >
                      工事番号
                    </StyledTableCell>
                    {userMenu != 'BM' && (
                      <>
                        <StyledTableCell
                          style={{ minWidth: 80 }}
                          className={classes.table}
                          align='center'
                        >
                          {/* ボタン */}
                        </StyledTableCell>
                        <StyledTableCell
                          style={{ minWidth: 80 }}
                          className={classes.table}
                          align='center'
                        >
                          {/* ボタン */}
                        </StyledTableCell>
                      </>
                    )}
                    {/* NOTE: メニュー出し分けリリースまでの暫定対応 */}
                    {userSiteManagePlan != 99 && (
                      <StyledTableCell
                        style={{ minWidth: 80 }}
                        className={classes.table}
                        align='center'
                      >
                        {/* ボタン */}
                      </StyledTableCell>
                    )}
                    {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                      <>
                        {userMenu != 'Storage' && (
                          <>
                            <StyledTableCell
                              style={{ minWidth: 100 }}
                              className={classes.table}
                              align='center'
                            >
                              受注金額
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ minWidth: 100 }}
                              className={classes.table}
                              align='center'
                            >
                              売上見込
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ minWidth: 110 }}
                              className={classes.table}
                              align='center'
                            >
                              計画粗利率
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ minWidth: 110 }}
                              className={classes.table}
                              align='center'
                            >
                              実行粗利率
                            </StyledTableCell>
                            <StyledTableCell
                              style={{ minWidth: 110 }}
                              className={classes.table}
                              align='center'
                            >
                              竣工日
                            </StyledTableCell>
                          </>
                        )}
                        {/* <StyledTableCell
                          className={classes.table}
                          align="center"
                        ></StyledTableCell> */}

                        {extInfo?.columns &&
                          extInfo?.columns.length > 0 &&
                          extInfo?.columns.map((column, index) => {
                            return (
                              <StyledTableCell
                                style={{ minWidth: 100 }}
                                className={classes.table}
                                align='center'
                                key={index}
                              >
                                {column.item}
                              </StyledTableCell>
                            );
                          })}
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {apiData.map((row: any, index: number) => (
                    <StyledTableRow
                      className='click_table_row'
                      title='編集'
                      // onClick={() => {
                      //   history.push(`/constructions/${row.id}/edit`, {
                      //     state: row.id,
                      //   });
                      // }}
                    >
                      {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                        <>
                          <StyledTableCell
                            className={classes.table1}
                            align='center'
                          >
                            <CustomTooltip
                              title={tooltipContents.selectDelete}
                              placement='top'
                            >
                              <Checkbox
                                checked={checked.check[index] ? true : false}
                                onClick={() => {
                                  handleChange(index);
                                  let newArr = selectedIds.arr;
                                  if (
                                    !checked.check[index] &&
                                    !pressed[index]
                                  ) {
                                    newArr.push(row.id);
                                    setSelectedIds({ arr: newArr });
                                  } else {
                                    var ind = selectedIds.arr.indexOf(row.id);
                                    if (ind !== -1)
                                      selectedIds.arr.splice(ind, 1);
                                  }
                                  setCheckBoxSelected(!checkBoxSelected);
                                }}
                                style={{
                                  color: checked.check[index]
                                    ? buttonColor
                                    : '#758283'
                                }}
                              />
                            </CustomTooltip>
                          </StyledTableCell>
                          {userMenu != 'Storage' && (
                            <StyledTableCell
                              className={classes.table1}
                              style={{ minWidth: 150 }}
                              align='center'
                            >
                              <div className={classes.inputContainerSelectBox}>
                                <select
                                  value={row.progress_status}
                                  onChange={e => {
                                    updateStatus(
                                      parseInt(row.id),
                                      parseInt(e.target.value)
                                    );
                                  }}
                                  className={classes.selectBoxStyle}
                                >
                                  <option value={1}>未契約</option>
                                  <option value={2}>営業中(Aランク)</option>
                                  <option value={3}>営業中(Bランク)</option>
                                  <option value={4}>営業中(Cランク)</option>
                                  <option value={5}>契約</option>
                                  <option value={6}>工事中</option>
                                  <option value={7}>竣工</option>
                                  <option value={8}>引渡</option>
                                  <option value={9}>入金・完工</option>
                                  <option value={10}>不成立</option>
                                  <option value={11}>是正</option>
                                </select>
                              </div>
                            </StyledTableCell>
                          )}
                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 100 }}
                            align='center'
                            onClick={() => {
                              history.push(`/constructions/${row.id}/edit`, {
                                state: row.id,
                                params: params,
                                currentPage: currentPage
                              });
                            }}
                          >
                            {row.assignee_user}
                          </StyledTableCell>
                        </>
                      )}
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/constructions/${row.id}/edit`, {
                            state: row.id,
                            params: params,
                            currentPage: currentPage
                          });
                        }}
                      >
                        {row.name}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/constructions/${row.id}/edit`, {
                            state: row.id,
                            params: params,
                            currentPage: currentPage
                          });
                        }}
                      >
                        {row.construct_type}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/constructions/${row.id}/edit`, {
                            state: row.id,
                            params: params,
                            currentPage: currentPage
                          });
                        }}
                      >
                        {row.customer_name}
                      </StyledTableCell>
                      <StyledTableCell
                        className={classes.table1}
                        style={{ minWidth: 100 }}
                        align='center'
                        onClick={() => {
                          history.push(`/constructions/${row.id}/edit`, {
                            state: row.id,
                            params: params,
                            currentPage: currentPage
                          });
                        }}
                      >
                        {row.code !== undefined ? row.code : ''}
                      </StyledTableCell>
                      {userMenu != 'BM' && (
                        <>
                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 100 }}
                            align='center'
                          >
                            <ListButton
                              variant='contained'
                              onClick={() => {
                                history.push(`/files`, {
                                  state: { id: row.id, name: row.name },
                                  params: params
                                });
                              }}
                            >
                              資料一覧
                            </ListButton>
                          </StyledTableCell>
                          <StyledTableCell
                            className={classes.table1}
                            style={{ minWidth: 100 }}
                            align='center'
                          >
                            <ListButton
                              variant='contained'
                              onClick={() => {
                                history.push(`/pictures`, {
                                  state: { id: row.id, name: row.name },
                                  params: params
                                });
                              }}
                            >
                              写真一覧
                            </ListButton>
                          </StyledTableCell>
                        </>
                      )}
                      {/* NOTE: メニュー出し分けリリースまでの暫定対応 */}
                      {userSiteManagePlan != 99 && (
                        <StyledTableCell
                          className={classes.table1}
                          style={{ minWidth: 90 }}
                          align='center'
                        >
                          <ListButton
                            variant='contained'
                            onClick={() => {
                              history.push(`/processes`, {
                                constructId: row.id,
                                name: row.name,
                                params: params
                              });
                            }}
                          >
                            工程表
                          </ListButton>
                        </StyledTableCell>
                      )}
                      {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                        <>
                          {userMenu != 'Storage' && (
                            <>
                              <StyledTableCell
                                className={classes.table1}
                                style={{ minWidth: 100 }}
                                align='right'
                                onClick={() => {
                                  history.push(
                                    `/constructions/${row.id}/edit`,
                                    {
                                      state: row.id,
                                      params: params,
                                      currentPage: currentPage
                                    }
                                  );
                                }}
                              >
                                {parsePrice(row.order_amount)}
                              </StyledTableCell>
                              <StyledTableCell
                                className={classes.table1}
                                style={{ minWidth: 100 }}
                                align='right'
                                onClick={() => {
                                  history.push(
                                    `/constructions/${row.id}/edit`,
                                    {
                                      state: row.id,
                                      params: params,
                                      currentPage: currentPage
                                    }
                                  );
                                }}
                              >
                                {parsePrice(row.expected_sales_amount)}
                              </StyledTableCell>
                              <StyledTableCell
                                className={classes.table1}
                                style={{ minWidth: 110 }}
                                align='center'
                                onClick={() => {
                                  history.push(
                                    `/constructions/${row.id}/edit`,
                                    {
                                      state: row.id,
                                      params: params,
                                      currentPage: currentPage
                                    }
                                  );
                                }}
                              >
                                {row.planned_gross_profit_rate}%
                              </StyledTableCell>
                              <StyledTableCell
                                className={classes.table1}
                                style={{ minWidth: 110 }}
                                align='center'
                                onClick={() => {
                                  history.push(
                                    `/constructions/${row.id}/edit`,
                                    {
                                      state: row.id,
                                      params: params,
                                      currentPage: currentPage
                                    }
                                  );
                                }}
                              >
                                {row.execustion_gross_profit_rate}%
                              </StyledTableCell>
                              <StyledTableCell
                                className={classes.table1}
                                style={{ minWidth: 220 }}
                                align='left'
                              >
                                <div
                                  style={{
                                    marginLeft: 10,
                                    marginRight: 15,
                                    backgroundColor: '#FFFFFF',
                                    height: 28,
                                    paddingBottom: 5,
                                    paddingLeft: 5
                                  }}
                                  className={'select-div-div'}
                                >
                                  <DatePickerInput
                                    id={`end_date${index}`}
                                    date={
                                      row.datetime_end_date !== ''
                                        ? row.datetime_end_date
                                        : null
                                    }
                                    emptyLabel='日付を選択'
                                    onChange={val => {
                                      handleEndDate(row.id, val);
                                    }}
                                    disabled={
                                      authInfo?.role == ROLE['OUTSIDE_PARTNER']
                                    }
                                  />
                                </div>
                              </StyledTableCell>
                            </>
                          )}
                          {addRow(row)}
                        </>
                      )}
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              {!loading && apiData.length === 0 && (
                <div className={classes.container}>データがありません</div>
              )}
            </TableContainer>
            <PaginationComponent
              page={currentPage}
              pageCount={pageCount}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};
